const SESSION_DATETIME_OPTIONS = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
};

const SESSION_TIME_OPTIONS = {
  hour: 'numeric',
  minute: '2-digit',
};

/** Session timestamps for lists and headers (date + time, minute precision). */
export function formatSessionDateTime(dateString) {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return 'N/A';
  return date.toLocaleString(undefined, SESSION_DATETIME_OPTIONS);
}

/** Inline message timestamps (time only, minute precision). */
export function formatSessionTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString(undefined, SESSION_TIME_OPTIONS);
}
